module.exports = "<h2>{{ 'NotFoundSOC' | i18next }}</h2>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/notFound/notFound.component.html
// module id = ../../../../../src/app/helpers/components/notFound/notFound.component.html
// module chunks = main